import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Container, UncontrolledTooltip } from 'reactstrap';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TableContainer from 'components/Common/TableContainer';
import { Link } from 'react-router-dom';
import { getVerifierWiseCurrentCallingStatus } from 'BaseComponentAPI/VerifierwiseCurrentCallingAPI';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';

const VerfierWiseCurrentCallingStatus = () => {
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";


    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [loaderOption, setLoaderOption] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupType, setPopupType] = useState('');

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const columns = useMemo(
        () => [
            {
                header: "Verifier Name",
                accessorKey: "userName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Current Status",
                accessorKey: "currentLoginStatus",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Assignment Status",
                accessorKey: "assignmentStatus",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Board Name",
                accessorKey: "callBoardName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Process Cnt",
                accessorKey: "callProcessCnt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Connected Calls Cnt",
                accessorKey: "connectedCallsCnt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Converted Lead Cnt",
                accessorKey: "convertedLeadCnt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Time Duration",
                accessorKey: "callTimeDuration",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: true,
                cell: cellProps => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                                <Link
                                    to="/job-details"
                                    className="btn btn-sm btn-soft-primary"
                                    id={`viewtooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-eye-outline" />
                                </Link>
                            </li>
                            <UncontrolledTooltip
                                placement="top"
                                target={`viewtooltip-${cellProps.row.original.id}`}
                                transition={{ timeout: 0 }}
                            >
                                Show Details
                            </UncontrolledTooltip>
                        </ul>
                    )
                },
            },
        ],
        []
    )

    const [data, setData] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(8);
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');

    const handlePageChange = async (newPageNo, newPageSize) => {
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(`${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`)
            try {
                const response = await axios.get(
                    `${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
                    {
                        headers: { ...authUser.headers },
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.items);
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);
                    setLoaderOption(false);
                } else {
                    setLoaderOption(false);
                    openPopup('Something went wrong!', 'error');
                    console.error('API Response Error:', response.data.responseMsg);
                }
            } catch (error) {
                setLoaderOption(false);
                openPopup('Something went wrong!', 'error');
                console.error('Error fetching data:', error);
            }
        }
    };

    useEffect(() => {
        if (!canRead) {
            openPopup('Something went wrong!', 'error');
        }
        else {
            getData();
        }

    }, [authUser]);

    const getData = async () => {
        setLoaderOption(true);
        setData([]);
        setTotalPages('');
        setTotalItems('');
        setNextPage('');
        setPreviousPage('');
        setCurrentPage('');
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(`${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`)
            try {
                const response = await axios.get(
                    `${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`,
                    {
                        headers: { ...authUser.headers },
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.items);
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);
                    setLoaderOption(false);
                } else {
                    setLoaderOption(false);
                    openPopup('Something went wrong!', 'error');
                    console.error('API Response Error:', response.data.responseMsg);
                }
            } catch (error) {
                setLoaderOption(false);
                openPopup('Something went wrong!', 'error');
                console.error('Error fetching data:', error);
            }
        }
    };

    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(data);  // Convert data to worksheet
        const wb = XLSX.utils.book_new();  // Create a new workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Verifier Data');  // Append the worksheet to the workbook
        //XLSX.writeFile(wb, 'VerifierWiseCurrentCallingStatus.xlsx');  // Trigger the download
        // Get the current date and time in IST
        const currentDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });

        // Format the date in yyyy-mm-dd hh:mm:ss format (example: 2025-01-28 14:30:45)
        const formattedDate = currentDate.replace(',', '').replace(/\//g, '-').replace(/:/g, '-').split(' ')[0] + ' ' + currentDate.split(' ')[1];

        // Set the file name with Current Calling Status + date & time
        const fileName = `VerifierWiseCurrentCallingStatus ${formattedDate}.xlsx`;

        // Trigger the download with the dynamic file name
        XLSX.writeFile(wb, fileName);  // Trigger the download with the formatted file name
    };

    if (loaderOption === true) {
        return (
            <>
                <Loader />
            </>
        );
    } else {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Report" breadcrumbItem="Verifier Wise Current Calling Status" />
                        <Card>
                            <CardBody>
                                {data && (
                                    <div className='mt-3'>
                                        <div className="d-flex align-items-center justify-content-end">
                                            <div className="flex-shrink-0">
                                                <button
                                                    onClick={exportToExcel}  // Trigger the export function
                                                    className="btn btn-primary me-1"
                                                >
                                                    Export Excel
                                                </button>
                                            </div>
                                        </div>
                                        <TableContainer
                                            columns={columns}
                                            data={data || []}
                                            isGlobalFilter={true}
                                            isPagination={true}
                                            SearchPlaceholder="Search..."
                                            isCustomPageSize={true}
                                            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                            theadClass="table-light"
                                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            pagination="pagination"
                                            getRowProps={row => ({
                                                className: "",
                                            })}
                                            onPageChange={handlePageChange} // Pass page change handler
                                            onPageSizeChange={handlePageChange} // Pass page size change handler
                                            pageSize={pageSize}
                                            setPageSize={setPageSize}
                                            totalPages={totalPages}
                                            totalItems={totalItems}
                                            tableNextPage={nextPage}
                                            tablePreviousPage={previousPage}
                                            tableCurrentPage={currentPage}
                                        />
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Container>
                </div>

                {isPopupVisible && (
                    <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                )}
            </React.Fragment>
        );
    }
};

export default VerfierWiseCurrentCallingStatus;
